import { render, staticRenderFns } from "./locationForm.vue?vue&type=template&id=4525fef2&%23default=true&"
import script from "./locationForm.vue?vue&type=script&lang=js&"
export * from "./locationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports